import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import $ from "jquery";

const UpdateRateList = ({ selectedRowsData, updateHandleChange, getData }) => {
  // const companyName = selectedRowsData.company?.company_name || "";
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [productName, setProductName] = useState("");
  const [storeProduct, setStoreProduct] = useState([]);
  const [discomId, setDiscomId] = useState("");
  const [storeDiscom, setStoreDiscom] = useState([]);

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  function resetFields() {
    setDiscomId("");
    setStoreProduct([]);
    setProductName([]);
  }
  const handleUpdateDataSubmit = async (e) => {
    e.preventDefault();
    const { id, circle, product_name, govt_rate, private_rate, tkcs_rate } =
      selectedRowsData;

    let BASE_URL = SERVER_URL + `/api/rate-list/rate-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        discom_id: discomId,
        circle,
        product_name,
        govt_rate,
        private_rate,
        tkcs_rate,
      }),
    });
    const response = await res.json();
    closeModal();
    if (res.ok) {
      getData();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const getProductData = async () => {
    let BASE_URL = SERVER_URL + `/api/product/all-products-distinct/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStoreProduct(result.data);
    } else {
      setStoreProduct([]);
    }
  };
  useEffect(() => {
    getProductData();
  }, [productName]);

  const handleDiscomChange = (e) => {
    setDiscomId(e.target.value);
  };

  const getDiscomData = async () => {
    let BASE_URL = SERVER_URL + `/api/discom/all-discoms/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStoreDiscom(result.data);
    } else {
      setStoreDiscom([]);
    }
  };

  useEffect(() => {
    getDiscomData();
  }, []);

  useEffect(() => {
    if (selectedRowsData) {
      setDiscomId(selectedRowsData?.discomList?.id);
    }
  }, [selectedRowsData]);

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Rate
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      onSubmit={handleUpdateDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="circle">Circle</label>
                            <input
                              type="text"
                              className="form-control"
                              name="circle"
                              id="circle"
                              placeholder="Circle"
                              value={selectedRowsData?.circle}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Pole">Size</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="product_name"
                              id="Pole"
                              onChange={updateHandleChange}
                              value={selectedRowsData?.product_name}
                              required
                            >
                              <option value="">Select Size</option>
                              {storeProduct &&
                                storeProduct.length > 0 &&
                                storeProduct?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.size}
                                      key={id}
                                    >{`${item.size}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Pole">Discom</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="discom_id"
                              id="discom_id"
                              onChange={handleDiscomChange}
                              value={discomId}
                              required
                              autoComplete="off"
                            >
                              <option value="">Select Discom</option>
                              {storeDiscom &&
                                storeDiscom.length > 0 &&
                                storeDiscom?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.discom_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="govt">Govt Rate</label>
                            <input
                              type="number"
                              className="form-control"
                              name="govt_rate"
                              id="govt"
                              placeholder="Govt Rate"
                              value={selectedRowsData?.govt_rate}
                              onChange={updateHandleChange}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="private">Private Rate</label>
                            <input
                              type="number"
                              className="form-control"
                              name="private_rate"
                              id="private"
                              placeholder="Private Rate"
                              value={selectedRowsData?.private_rate}
                              onChange={updateHandleChange}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="circle">TKCS Rate</label>
                            <input
                              type="number"
                              className="form-control"
                              name="tkcs_rate"
                              id="circle"
                              placeholder="TKCS Rate"
                              value={selectedRowsData?.tkcs_rate}
                              onChange={updateHandleChange}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleUpdateDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateRateList;
